"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Handle = function Handle(_ref) {
  var _ref$handle = _ref.handle,
      id = _ref$handle.id,
      value = _ref$handle.value,
      percent = _ref$handle.percent,
      getHandleProps = _ref.getHandleProps,
      handlePrefix = _ref.handlePrefix;
  return /*#__PURE__*/_react.default.createElement(StyledHandle, _extends({
    percent: percent
  }, getHandleProps(id)), handlePrefix ? handlePrefix : '', value);
};

var StyledHandle = _styledComponents.default.div.withConfig({
  displayName: "StyledHandle"
})(["left:", ";position:absolute;margin-left:3px;margin-top:3px;z-index:2;width:50px;height:30px;border:0;cursor:pointer;border-radius:5px;background-color:white;display:flex;justify-content:center;align-items:center;font-family:", ";font-weight:500;font-size:1.4rem;line-height:1.8rem;text-align:center;color:", ";"], function (_ref2) {
  var percent = _ref2.percent;
  return "".concat(percent, "%");
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.typo.title;
});

Handle.propTypes = {
  handle: _propTypes.object,
  id: _propTypes.string,
  value: _propTypes.number,
  percent: _propTypes.number,
  getHandleProps: _propTypes.object,
  handlePrefix: _propTypes.string
};
var _default = Handle;
exports.default = _default;